<script lang="ts">
    import LogoColors from '$lib/components/assets/LogoColors.svelte';
    import {getContext} from 'svelte';
    import {keyPlatform} from '$lib/context-keys';

    const platform = getContext(keyPlatform)
</script>

<footer>
    <div class="footer-content">
        <div class="footer-logo">
            <a href="/">
                <LogoColors/>
            </a>
        </div>
        <nav aria-labelledby="footer-navigation">
            <div class="column">
                <span class="column-title">Product</span>
                <ul>
                    <li>
                        <a href="/browse">Dictionary</a>
                    </li>
                    <li>
                        <a href="/learn">Vocabulary Trainer</a>
                    </li>
                    <li>
                        <a href="/pricing">Plans & Pricing</a>
                    </li>
                    <li>
                        <a href="/german-vocabulary">Word Lists</a>
                    </li>
                    <!--                    <li>-->
                    <!--                        <a href="/pricing">Contact</a>-->
                    <!--                    </li>-->
                </ul>
            </div>
            <div class="column">
                <span class="column-title">Legal</span>
                <ul>
                    <li>
                        <a href="/legal/notice">Legal Notice</a>
                    </li>
                    <li>
                        <a href="/legal/terms">Terms of Service</a>
                    </li>
                    <li>
                        <a href="/legal/privacy">Privacy Policy</a>
                    </li>
                    <li>
                        <a href="/legal/cookie">Cookie Policy</a>
                    </li>
                </ul>
            </div>
            {#if platform === 'web'}
                <div class="column">
                    <span class="column-title">Compare</span>
                    <ul>
                        <li>
                            <a href="/comparison/vocabeo-vs-duolingo">vocabeo vs Duolingo</a>
                        </li>
                        <li>
                            <a href="/comparison/vocabeo-vs-quizlet">vocabeo vs Quizlet</a>
                        </li>
                        <li>
                            <a href="/comparison/vocabeo-vs-anki">vocabeo vs Anki</a>
                        </li>
                        <li>
                            <a href="/comparison/vocabeo-vs-clozemaster">vocabeo vs Clozemaster</a>
                        </li>
                    </ul>
                </div>
            {/if}
        </nav>
    </div>
</footer>

<style>
    footer {
        padding-inline: var(--page-padding-inline);
        font-size: .9rem;
    }

    .footer-content {
        display: flex;
        padding-top: 2rem;
        padding-bottom: 6rem;
        align-items: flex-start;
        border-top: 3px solid var(--color-dark);
    }

    @media (max-width: 1000px) {
        .footer-content {
            padding-bottom: 3rem;
        }
    }

    .footer-logo {
        width: 2.6rem;
        height: 2.6rem;
        flex-shrink: 0;
        margin-left: 2rem;
        margin-right: 4rem;
    }

    @media (max-width: 500px) {
        .footer-logo {
            margin-left: 1rem;
            margin-right: 3rem;
        }
    }

    .footer-logo a {
        display: block;
    }

    .footer-logo a :global(svg) {
        display: block;
    }

    nav {
        display: flex;
        flex-wrap: wrap;
        gap: 2rem 2rem;
    }

    .column {
        width: 11rem;
        display: flex;
        flex-direction: column;
        gap: var(--space-md);
    }

    .column-title {
        font-weight: var(--font-emph);
    }

    ul {
        list-style: none;
        display: grid;
        align-content: flex-start;
        gap: .8rem;
        margin: 0;
        padding: 0;
        line-height: 1;
    }

    li {
        white-space: nowrap;
    }

    a {
        text-decoration: none;
        color: var(--color-main);
    }
</style>